
/*
 * ------------------------------------------------------------
 * NBHAS Report Renderer
 * Version: 1.0.0
 * ------------------------------------------------------------
 */
console.log('✅ nbhas-report-renderer.js loaded');

(function () {

    if (!window.NBHAS) {
        window.NBHAS = {};
    }

    const reportRenderer = {

        render() {

            if (!NBHAS.report ||
                !NBHAS.report.hasAssessment()) {

                console.warn(
                    'No completed assessment.'
                );

                return;
            }

            const data =
                NBHAS.report.buildReportData();

let container =
    document.getElementById(
        'nbhas-report-preview'
    );

if (!container) {

    container =
        document.createElement('div');

    container.id =
        'nbhas-report-preview';

    const resultsContainer =
        document.getElementById(
            'nbhas-results'
        );

    if (resultsContainer) {

        resultsContainer.insertAdjacentElement(
            'afterend',
            container
        );

    } else {

        document.body.appendChild(
            container
        );
    }
}container.style.position = 'relative';
container.style.left = '0';
container.style.top = '0';
container.style.width = '720px';
container.style.maxWidth = 'calc(100% - 32px)';
container.style.boxSizing = 'border-box';
container.style.background = '#ffffff';
container.style.padding = '40px';
container.style.margin = '40px auto';
container.style.display = 'block';

container.innerHTML = `

    ${renderHeader(data)}

    ${renderSummary(data)}

    ${renderRecommendation(data)}

    ${renderIndicators(data)}

    ${renderResources(data)}

    ${renderSymptoms(data)}

    ${renderFooter(data)}

`;

return container;



}

}

/**
 * Ensure Shopify asset URLs are absolute.
 */
function normalizeAssetUrl(url) {

    if (!url) {
        return '';
    }

    if (url.startsWith('//')) {
        return `https:${url}`;
    }

    return url;
}

function renderHeader(data) {

    const logoUrl = normalizeAssetUrl(
        window.NBHAS_LOGO_URL
    );

    return `
        <header class="nbhas-report-header">

            ${logoUrl ? `
                <img
                    class="nbhas-report-logo"
                    src="${logoUrl}"
                    alt="Nature's Balance">
            ` : ''}

            <h1>
                Hormone Assessment Report
            </h1>

            <p class="nbhas-report-subtitle">
                Personalized Results &amp; Recommendations
            </p>

        </header>
    `;
}

 function renderSummary(data) {

    const scores =
        Object.values(
            data.results?.scores || {}
        );

    const primaryScore =
        scores[0] || null;

    const completedDate =
        new Date(
            data.completedAt
        ).toLocaleDateString();

    return `
        <section class="nbhas-report-section">

            <h3>
                Your Assessment at a Glance
            </h3>

            <p>
                <strong>Assessment completed:</strong>
                ${completedDate}
            </p>

            <p>
                <strong>Symptoms answered:</strong>
                ${data.answers?.answeredCount || 0}
            </p>

            <p>
                <strong>Total symptom score:</strong>
                ${data.answers?.totalScore || 0}
            </p>

            ${
                primaryScore
                    ? `
                        <p>
                            <strong>
                                Primary assessment result:
                            </strong>

                            ${primaryScore.title}
                        </p>

                        <p>
                            <strong>Assessment score:</strong>
                            ${primaryScore.percent}%
                            (${primaryScore.raw} of
                            ${primaryScore.max})
                        </p>
                    `
                    : ''
            }

        </section>
    `;
}

function renderIndicators(data) {

    const symptoms =
        data.answers?.symptoms || [];

    const indicators =
        symptoms
            .filter(
                symptom =>
                    Number(symptom.score) >= 2
            )
            .sort(
                (a, b) =>
                    Number(b.score) -
                    Number(a.score)
            );

    if (!indicators.length) {

        return `
            <section class="nbhas-report-section">

                <h3>
                    Strongest Indicators
                </h3>

                <p>
                    No moderate or severe symptoms
                    were recorded.
                </p>

            </section>
        `;
    }

    return `
        <section class="nbhas-report-section">

            <h3>
                Strongest Indicators
            </h3>

            <ul>
                ${
                    indicators
                        .map(
                            symptom => `
                                <li>
                                    ${escapeHTML(
                                        symptom.symptomName
                                    )}
                                    —
                                    ${getSeverityLabel(
                                        symptom.score
                                    )}
                                </li>
                            `
                        )
                        .join('')
                }
            </ul>

        </section>
    `;
}

function renderRecommendation(data) {

    const recommendations =
        data.results?.recommendations ||
        data.recommendations ||
        [];

    if (!recommendations.length) {
        return '';
    }

const getRecommendationId =
    recommendation =>
        recommendation.id ||
        recommendation.RecommendationID ||
        '';

const product =
    NBHAS.recommendedProduct;

const hasEst =
    recommendations.some(
        recommendation =>
            getRecommendationId(
                recommendation
            ) === 'REC-EST'
    );

const hasProg =
    recommendations.some(
        recommendation =>
            getRecommendationId(
                recommendation
            ) === 'REC-PROG'
    );

    if (hasEst && hasProg) {

        const productHandle =
            'bio-identical-estradiol-and-progesterone-cream-pack';

        const productUrl =
            `/products/${productHandle}`;

        const educationPage =
            '/pages/understanding-hormone-balance';

        const productImage =
            'https://cdn.shopify.com/s/files/1/0752/9922/5827/files/main_image_nature.jpg';

        return `
            <section class="nbhas-report-section">

                <h3>
                    Recommended Support
                </h3>

                <h4>
                    Low Estrogen + Low Progesterone
                </h4>

                <p>
                    Your responses suggest that both low estrogen
                    and low progesterone may be contributing to
                    your symptoms.
                </p>

                <p>
                    <strong>
                        Recommended product:
                    </strong>

                    Nature's Balance Bio-Identical Estradiol
                    &amp; Progesterone Cream Pack
                </p>

                <p>
                    Recommended when your assessment suggests
                    support for both estrogen and progesterone
                    balance.
                </p>

<div class="nbhas-report-product-row">

    <a
        href="${productUrl}"
        class="nbhas-report-product-image-link"
    >
        <img
            class="nbhas-report-product-image"
            src="${productImage}"
            alt="Nature's Balance Bio-Identical Estradiol and Progesterone Cream Pack"
        >
    </a>

    <div class="nbhas-report-product-links">

        <p>
            <a href="${productUrl}">
                View Product
            </a>
        </p>

        <p>
            <a href="${educationPage}">
                Learn More
            </a>
        </p>

    </div>

</div>
            </section>
        `;
    }

return recommendations
    .map(recommendation => {

        const recommendationId =
            getRecommendationId(
                recommendation
            );

        const title =
            recommendation.AssessmentTitle ||
            recommendation.Name ||
            '';

        const summary =
            recommendation.AssessmentSummary ||
            recommendation.Summary ||
            '';

        let productHandle = '';
        let educationPage = '';

        if (
            recommendationId ===
            'REC-EST'
        ) {
            productHandle =
                'bioidentical-estradiol-cream';

            educationPage =
                '/pages/understanding-low-estrogen';
        }

        if (
            recommendationId ===
            'REC-PROG'
        ) {
            productHandle =
                'bioidentical-progesterone-cream';

            educationPage =
                '/pages/understanding-low-progesterone';
        }

        if (
            recommendationId ===
            'REC-MEL'
        ) {
            productHandle =
                'all-natural-melatonin-cream';

            educationPage =
                '/pages/understanding-melatonin';
        }

        const product =
            NBHAS.recommendedProduct;

        const productUrl =
            product?.url ||
            `/products/${productHandle}`;

        const productTitle =
            product?.title ||
            recommendation.ProductTitle ||
            recommendation.Name ||
            '';

        const productImage =
            product?.featuredImage ||
            '';

        return `
            <section class="nbhas-report-section">

                <h3>
                    Recommended Support
                </h3>

            ${
                title
                    ? `
                <h4>
                    ${escapeHtml(title)}
                </h4>
                    `
                : ''
            }
                ${
                    summary
                        ? `
                            <p>
                                ${escapeHtml(summary)}
                            </p>
                        `
                        : ''
                }

                ${
                    productTitle
                        ? `
                            <p>
                                <strong>
                                    Recommended product:
                                </strong>

                                ${escapeHtml(productTitle)}
                            </p>
                        `
                        : ''
                }

                <div class="nbhas-report-product-row">

                    ${
                        productImage
                            ? `
                                <a href="${productUrl}">
                                    <img
                                        class="nbhas-report-product-image"
                                        src="${productImage}"
                                        alt="${escapeHtml(productTitle)}"
                                    >
                                </a>
                            `
                            : ''
                    }

                    <div class="nbhas-report-product-links">

                        <p>
                            <a href="${productUrl}">
                                View Product
                            </a>
                        </p>

                        ${
                            educationPage
                                ? `
                                    <p>
                                        <a href="${educationPage}">
                                            Learn More
                                        </a>
                                    </p>
                                `
                                : ''
                        }

                    </div>

                </div>

            </section>
        `;
    })
    .join('');

}

function renderSymptoms(data) {

    const sections =
        Object.values(
            data.answers?.sectionScores || {}
        );

    const populatedSections =
        sections.filter(
            section =>
                Array.isArray(section.symptoms) &&
                section.symptoms.length
        );

    if (!populatedSections.length) {

        return `
            <section class="nbhas-report-section nbhas-report-recommendation">

                <h3>
                    Detailed Symptom Responses
                </h3>

                <p>
                    No symptom responses were recorded.
                </p>

            </section>
        `;
    }

    return `
        <section class="nbhas-report-section nbhas-report-recommendation">

            <h3>
                Detailed Symptom Responses
            </h3>

            ${
                populatedSections
                    .map(
                        section => `
                            <div class="
                                nbhas-report-symptom-section
                            ">

                                <h4>
                                    ${escapeHTML(
                                        section.sectionName
                                    )}
                                </h4>

                                <p>
                                    Answered:
                                    ${section.answeredCount}

                                    &nbsp;|&nbsp;

                                    Score:
                                    ${section.score}
                                </p>

                                <ul>
                                    ${
                                        section.symptoms
                                            .map(
                                                symptom => `
                                                    <li>
                                                        ${
                                                            escapeHTML(
                                                                symptom
                                                                    .symptomName
                                                            )
                                                        }

                                                        —
                                                        ${
                                                            getSeverityLabel(
                                                                symptom.score
                                                            )
                                                        }
                                                    </li>
                                                `
                                            )
                                            .join('')
                                    }
                                </ul>

                            </div>
                        `
                    )
                    .join('')
            }

        </section>
    `;
}

function renderResources(data) {

    const recommendations =
        data.results?.recommendations || [];

    const resources = [];

    recommendations.forEach(
        recommendation => {

            if (
                recommendation
                    .educationPage
            ) {
                resources.push({
                    title:
                        `Learn more about ${
                            recommendation
                                .assessmentTitle ||
                            recommendation.name
                        }`,
                    url:
                        recommendation
                            .educationPage
                });
            }

            if (
                recommendation
                    .shopifyProductHandle
            ) {
                resources.push({
                    title:
                        recommendation
                            .productTitle ||
                        'View Recommended Product',
                    url:
                        `/products/${
                            recommendation
                                .shopifyProductHandle
                        }`
                });
            }
        }
    );

    if (!resources.length) {

        return `
            <section class="nbhas-report-section">

                <h3>
                    Helpful Resources
                </h3>

                <p>
                    No additional resources
                    were generated.
                </p>

            </section>
        `;
    }

    return `
        <section class="nbhas-report-section">

            <h3>
                Helpful Resources
            </h3>

            <ul>
                ${
                    resources
                        .map(
                            resource => `
                                <li>
                                    <a
                                        href="${resource.url}"
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        ${escapeHTML(
                                            resource.title
                                        )}
                                    </a>
                                </li>
                            `
                        )
                        .join('')
                }
            </ul>

        </section>
    `;
}

function renderFooter(data) {

    const completedDate =
        data.completedAt
            ? new Date(
                data.completedAt
            ).toLocaleString()
            : '';

    const engineVersion =
        data.results?.meta
            ?.engineVersion || '1.0.0';

    const knowledgeVersion =
        data.results?.meta
            ?.knowledgeVersion || '';

    return `
        <footer class="nbhas-report-footer">

            <hr>

            <p>
                This assessment is intended
                for educational purposes only
                and is not a medical diagnosis.
            </p>

            ${
                completedDate
                    ? `
                        <p>
                            Completed:
                            ${escapeHTML(
                                completedDate
                            )}
                        </p>
                    `
                    : ''
            }

            <p>
                NBHAS Engine
                ${escapeHTML(
                    engineVersion
                )}

                ${
                    knowledgeVersion
                        ? `
                            &nbsp;|&nbsp;
                            Knowledge Base
                            ${escapeHTML(
                                knowledgeVersion
                            )}
                        `
                        : ''
                }
            </p>

            <p>
                Nature's Balance
            </p>

        </footer>
    `;
}

    function getSeverityLabel(score) {

    const labels = {
        0: 'None',
        1: 'Mild',
        2: 'Moderate',
        3: 'Severe'
    };

    return labels[
        Number(score)
    ] || 'Not answered';
}

function escapeHTML(value) {

    return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
}


    NBHAS.reportRenderer =
        reportRenderer;

})();


/**
 * Render the assessment report.
 */
function renderReportHTML(result) {

    const logoUrl = normalizeAssetUrl(
        window.NBHAS_LOGO_URL
    );

    return `
        <div class="nbhas-report">

            <div class="nbhas-report-header">

                <img
                    class="nbhas-report-logo"
                    src="${logoUrl}"
                    alt="Nature's Balance">

                <h1>Hormone Assessment Report</h1>

                <p>
                    Personalized Results & Recommendations
                </p>

            </div>

        </div>
    `;
}

window.renderReportHTML = renderReportHTML;
